export default __webpack_public_path__ + "static/media/quiz.afa68be9.svg";